module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pg-header"
  }, [_c('div', {
    staticClass: "pg-header-left"
  }, [_c('h1', {
    staticClass: "pg-h1"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.subtitle) ? _c('p', {
    staticClass: "pg-h1-sub"
  }, [_vm._v(_vm._s(_vm.subtitle))]) : _vm._e()]), _vm._v(" "), (_vm.$slots.action) ? _c('div', {
    staticClass: "pg-header-action"
  }, [_vm._t("action")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b66a124"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageTitle.vue
// module id = 1665
// module chunks = 2